import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface BrandNameFormattingCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const BrandNameFormattingCard: React.FC<BrandNameFormattingCardProps> = ({ guideline, index, onEditClick }) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'BrandNameFormatting') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Brand Name Formatting"
      onEditClick={onEditClick}
    >
      <Flex flexDirection="column" gap={8}>
        <Text variant="body2" fontWeight={500}>
          Brand Selection
        </Text>
        <Text variant="body2" sx={{ lineHeight: '30px' }}>{guideline.parameters.brandName}</Text>
      </Flex>
    </BaseRequirementCard>
  );
};
